module.exports = __webpack_public_path__ + "static/media/unchained.fe0f44aa.jpg";